import { styled, Button } from '@ori-ui/mui';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { localization } from '../../../shared/constants';
import { stateContext } from '../../../shared/contexts';
import { CustomerSelectionForm } from './CustomerSelectionForm';
import { FrequencySelection } from './FrequencySelection';

const StyledCustomerSelection = styled('div')(({ theme }) => ({
  display: 'grid',
  rowGap: theme.spacing(3),
  marginTop: theme.spacing(3),
  width: '100%',
  overflow: 'visible',
}));

export function CustomerSelection() {
  const { isCustomerSelectionValid, selectedFrequency, goToSummary } = useContext(stateContext);

  return (
    <StyledCustomerSelection>
      <FrequencySelection />
      <CustomerSelectionForm />
      <Button
        fullWidth
        color="primary"
        variant="contained"
        disabled={!(selectedFrequency && isCustomerSelectionValid)}
        onClick={goToSummary}
      >
        <FormattedMessage
          id="nextStep"
          defaultMessage={localization.nextStep}
        />
      </Button>
    </StyledCustomerSelection>
  );
}
